import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../../../Helpers/auth.provider";

export const PrivateRoute = ({ component: Component, ...rest }) => {
    const renderFn = (Component) => {
        const RenderComponent = (props) => (
            <AuthConsumer>
                {({ isAuthenticated, signinRedirect }) => {
                    if (!!Component && isAuthenticated()) {
                        return <Component {...props} />;
                    } else {
                        signinRedirect();
                        return <span>loading</span>;
                    }
                }}
            </AuthConsumer>
        );

        // Set display name for better debugging
        RenderComponent.displayName = `RenderComponent(${Component.displayName || Component.name || 'Component'})`;
        
        return RenderComponent;
    };

    return <Route {...rest} render={renderFn(Component)} />;
};